import getSelectedFolder from 'owa-mail-store/lib/utils/getSelectedFolder';
import { getFolderByDistinguishedId } from 'owa-folders';
import setUnseenCount from '../mutators/setUnseenCount';

export default function onPageVisibilityChanged() {
    if (getSelectedFolder() === getFolderByDistinguishedId('inbox') && document.hasFocus()) {
        setUnseenCount(0);
    }
}
